module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/modules/_library.js
// module id = 554
// module chunks = 0